// extracted by mini-css-extract-plugin
export default {"Planet":"planet_Planet__An1TJ","ground":"planet_ground__7JIXt","alien-group":"planet_alien-group__yBW9l"};